import ManualContribuyente from "../../components/manual/ManualContribuyente";

/** Manual del Contribuyente — vista dentro del Portal.
 *  Mismo componente reusable que se muestra en el backoffice.
 */
export default function PortalManualPage() {
  return (
    <div className="p-4 md:p-8" data-testid="portal-manual-page">
      <ManualContribuyente inPortal={true} />
    </div>
  );
}
